import type { echeances as Fr } from '../fr/echeances';

/** « echeances » in English — typed on the French: a missing sentence does not compile. */
export const echeances: typeof Fr = {
  badge: { depasse: 'Overdue', proche: 'Due soon', jamais: 'Never done', ok: 'Up to date' },
  erreurChargement: 'This list could not be loaded.',
  chargementImpossible: 'Unable to load',
  controle: 'Technical inspection',
  entretien: 'Maintenance',
  sousControle: 'A vehicle without a valid inspection can be taken off the road overnight',
  sousPeriode: (km: string, u: string) => `Every ${km} ${u} · one line per vehicle, most urgent first`,
  sousDefaut: 'One line per vehicle, most urgent first',
  enregistrerIntervention: 'Record a maintenance job',
  aTraiter: (n: number) => `${n} ${n === 1 ? 'vehicle' : 'vehicles'} to deal with`,
  depassees: (n: number) => `${n} overdue`,
  proches: (n: number, liste: string) => `${n} coming due: ${liste}.`,
  rien: 'Nothing to deal with',
  aucuneApproche: 'No vehicle is close to its due date',
  seuil: (u: string) => ` — the alert threshold is 1,000 ${u}`,
  toutesVoitures: 'All vehicles',
  parVoiture: 'By vehicle',
  aucuneFlotte: 'No vehicles in the fleet',
  aucuneFiltre: 'No vehicles for this filter',
  col: {
    vehicule: 'Vehicle', numero: 'Inspection no.', expire: 'Expires on', echeance: 'Due', etat: 'Status',
    compteur: 'Odometer', derniere: 'Last', prochaine: 'Next',
  },
  noteEntretien1: 'A vehicle turns red ',
  noteEntretienSeuil: (u: string) => `below 1,000 ${u}`,
  noteEntretien2: ': that is the distance it can cover in a single rental. Mileage comes from readings entered on the “My vehicles” screen and from inspections.',
  noteControle: 'The technical inspection is also shown on each vehicle’s record, with insurance and road tax. A vehicle whose inspection has expired must not go out.',
};
